import { createIcon } from '@chakra-ui/icons'
import React from 'react'
export const IconFileRemove = createIcon({
  displayName: 'IconFileRemove',
  path: [
    <path
      key="0"
      clipRule="evenodd"
      d="M13 2H15.41L20 6.59V22H4V2H11V4H6V20H18V9H13V2ZM15 4.41V7H17.59L15 4.41ZM9 13H15V15H9V13Z"
      fill="currentColor"
      fillRule="evenodd"
    />,
  ],
  viewBox: '0 0 24 24',
})
